<template>
  <section>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      :can-cancel="false"
    >
      <form v-on:submit.prevent="saveAnswer">
        <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <header class="modal-card-head">
            <p class="modal-card-title">Encuesta</p>
          </header>
          <section class="modal-card-body">
            <h1 class="title is-4" style="display: flex;
    flex-direction: row;">
              <img src="\images\Logo-SSM.jpg" width="90"/>
              <div style="margin-left: 1em">Nombre de la Encuesta: {{Questionarie.name}}</div>
            </h1>
    
            <h2 class="content" v-html="Questionarie.description"></h2>
            <div class="box" v-for="Question in Questions" :key="Question.id">
              <div class="content" v-html="Question.question"></div>
              <ul v-if="Question.type_selection_id == 1">
                <b-field
                  v-for="Answer in Question.questions_alternatives"
                  :key="Answer.alternative.id"
                >
                  <b-radio
                    v-show="Answer.alternative.alternative != 'En Blanco'"
                    v-model="Question.id_answer"
                    :native-value="Answer.alternative.id"
                    >{{ Answer.alternative.alternative }}
                  </b-radio>
                </b-field>
              </ul>
              <div v-else class="block" style="margin-top: 1em">
                <b-field
                  v-for="answer in Question.questions_alternatives"
                  :key="answer.alternative.id"
                >
                  <b-checkbox
                    v-show="answer.alternative.alternative != 'En Blanco'"
                    :native-value="answer.alternative.id"
                    v-model="Question.answers"
                  >
                    {{ answer.alternative.alternative }}
                  </b-checkbox>
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="closeBasic()">
              Cerrar
            </button>
            <button class="button is-primary" type="submit">Enviar encuesta</button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>
<script>
import { getQuestionarie } from "../../services/questionarie";
import { storeAnswer } from "../../services/answer";
import { storeUserQuestionarie } from "../../services/users_questionaries";

// import {
//   deleteQuestion,
//   editQuestion,
//   getQuestion,
// } from "../../services/question";

export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "questionarie_id",
    "chargeQuestionarieList",
  ],
  data() {
    return {
      isLoading: false,
      Questionarie: {
        name: "",
        description: "",
      },
      radio: "",
      Questions: [],
      test: [],
    };
  },
  created: function () {
    this.isLoading = true;
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.Questions = [];
      await getQuestionarie(this.$http, this.questionarie_id).then(
        (response) => {
          console.log("DATA:", response);
          this.Questionarie = response;
          response.questions.forEach((question) => {
            this.Questions.push({
              ...question,
              answers: [],
              id_answer: question.questions_alternatives.find(
                (element) => element.alternative.alternative == "En Blanco"
              ).alternative.id,
            });
          });
          this.isLoading = false;
        }
      );
    },
    async saveAnswer() {
      let withoutAnswer = false;
      for (let i = 0; i < this.Questions.length; i++) {
        const question = this.Questions[i];
        if (question.type_selection_id == 1) {
          if (!question.id_answer) {
            withoutAnswer = true;
          }
        } else {
          if (question.answers.length == 0) {
            // withoutAnswer = true;
            let alternativeId = question.questions_alternatives.find(
                (element) => element.alternative.alternative == "En Blanco"
              ).alternative.id;
            this.Questions[i].answers.push(alternativeId);
          }
          if (question.answers.length > 6) {
            this.$buefy.dialog.alert({
              title: "Falla de validación",
              message: `La pregunta ${question.question} solo permite seleccionar <b>6 opciones como máximo</b>, actualmente hay seleccionadas ${question.answers.length }`,
              type: "is-warning",
              hasIcon: true,
            });
            return;
          }
        }
      }

      if (!withoutAnswer) {
        this.isLoading = true;
        let data = {
          questionary_id: this.questionarie_id,
          user_id: JSON.parse(window.localStorage.getItem("user")).id,
          state: "Realizado",
        };
        await storeUserQuestionarie(this.$http, data).then((response) => {
          var id_user_questionarie = response.id;
          let promises = [];
          this.Questions.forEach(async (question) => {
            if (question.type_selection_id == 1) {
              promises.push(
                new Promise((resolve, reject) => {
                  let data = {
                    user_questionary_id: id_user_questionarie,
                    alternative_id: question.id_answer,
                    state: "Respondido",
                  };
                  storeAnswer(this.$http, data)
                    .then(() => {
                      resolve();
                    })
                    .catch(() => {
                      reject();
                    });
                })
              );
            } else {
              for (let i = 0; i < question.answers.length; i++) {
                const answer = question.answers[i];
                new Promise((resolve, reject) => {
                  let data = {
                    user_questionary_id: id_user_questionarie,
                    alternative_id: answer,
                    state: "Respondido",
                  };
                  storeAnswer(this.$http, data)
                    .then(() => {
                      resolve();
                    })
                    .catch(() => {
                      reject();
                    });
                });
              }
            }
          });
          Promise.all(promises).then(() => {
            this.toast("Encuesta Respondida", "is-success");
            this.isLoading = false;
            this.chargeQuestionarieList();
            this.closeBasic();
          });
        });
      } else {
        this.$buefy.dialog.alert({
          title: "Falla de validación",
          message: "Hay una o más preguntas sin respuesta.",
          type: "is-warning",
          hasIcon: true,
        });
      }
    },
  },
};
</script>